<template>
	<div class="action-bar">
		<el-button v-for="(action, i) in actions" :disabled="action.disabled" :type="action.type" :icon="action.icon" @click="onClickActionButton(action)" :key="i">{{ action.title }}</el-button>
	</div>
</template>

<script>
	
	export default {
		
		props: {
			actions: { type: Array },
		},
		
		methods: {
			onClickActionButton(actionButton) {
				this.$emit("click", actionButton);
			}
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/ActionBar.vue